export { default } from "../../ipd/utils/IpdSectionCard";
